import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#board',
			dom: {
				more: '#boardMore',
				letter: '.js-board-letter'
			},
			classes: {
				hidden: 'board__letter-mobile_hidden',
				nomore: 'board_nomore'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	get() {
		const {more, letter} = this.options.dom;

		this.$more = this.$el.find(more);
		this.$letter = this.$el.find(letter);

		return this;
	}

	check() {
		this.$el.toggleClass(this.options.classes.nomore, !this.$letter.filter('.' + this.options.classes.hidden).length);
		return this;
	}

	onMore() {
		const self = this;
		let count = 0;
		self.$letter.filter('.' + self.options.classes.hidden).each(function () {
			if (count < 5) {
				$(this).removeClass(self.options.classes.hidden);
			}
			count++;
		});

		self.check();
	}

	init() {
		this.$more.on('click', this.onMore.bind(this));
		return this;
	}

	render() {
		if (this.$el.length) {
			this
				.get()
				.init()
				.check();
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/board/board.js